import {Component, OnInit} from '@angular/core';
import { UserType } from '../../../Shared/Enums/UserType';
import { AuthService } from '../../../Shared/Services/auth.service';
import { Router } from '@angular/router';
import { NgxSpinnerService } from 'ngx-spinner';
import { takeUntil } from 'rxjs/internal/operators/takeUntil';
import { Subject } from 'rxjs/internal/Subject';
import { SharedService } from '../../../Shared/Services/shared.service';
import { environment } from '../../../../environments/environment'
import { FactoringService } from '../../../Services/factoring.service';
import {FactorModel} from "../../../Model/discount/factor.model";

@Component({
  selector: 'app-discountsfile',
  templateUrl: './discounts-file.component.html',
  styleUrl: './discounts-file.component.scss'
})
export class DiscountsfileComponent implements OnInit {
  private destroy$: Subject<boolean> = new Subject<boolean>();
  factors: FactorModel[] = [];
  attachmentsUrl: string = environment.attachmentsUrl;

  constructor(private api: FactoringService, private auth: AuthService, private spinner: NgxSpinnerService,
    private router: Router, private shared: SharedService) { }

  ngOnInit() {
    if (!this.auth.isAuthenticated([UserType.Workshop])) {
      this.router.navigateByUrl('dashboard/not-authorized');
    }
    this.GetAllFactor();
  }

  GetAllFactor() {
    this.spinner.show();
      this.api.GetAllFactor()
        .pipe(takeUntil(this.destroy$))
        .subscribe((data: any) => {
          if (data.status == 'success') {
            this.factors = data.payload;
          }
          this.spinner.hide();
        });
  }
}
